import createIcon from '../../createIcon';

/**
 * @component @name Flight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNSAxNlYxNEwxMy41IDlWMy41QzEzLjUgMi42NyAxMi44MyAyIDEyIDJDMTEuMTcgMiAxMC41IDIuNjcgMTAuNSAzLjVWOUwyLjUgMTRWMTZMMTAuNSAxMy41VjE5TDguNSAyMC41VjIyTDEyIDIxTDE1LjUgMjJWMjAuNUwxMy41IDE5VjEzLjVMMjEuNSAxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Flight = createIcon('Flight', [
  [
    'path',
    {
      d: 'M21.5 16V14L13.5 9V3.5C13.5 2.67 12.83 2 12 2C11.17 2 10.5 2.67 10.5 3.5V9L2.5 14V16L10.5 13.5V19L8.5 20.5V22L12 21L15.5 22V20.5L13.5 19V13.5L21.5 16Z',
      key: '18kv2a',
    },
  ],
]);

export default Flight;
